<template>
<div>
    <a-modal title="日期标注" :maskClosable="false" @cancel="reset" v-model="isShow" wrapClassName="manage_modal mark_manage_model">
        <div v-for="mark in marks" :key="mark.id" class="mark_list">
            <ul class="mark_list_list">
                <li><label>日期：</label>{{mark.start_dt}}~{{mark.end_dt}}</li>
                <li><label>标注：</label>{{mark.text}}</li>
                <li><label>补充：</label>{{mark.tooltip}}</li>
                <li><label>应用：</label>{{mark.is_all?'本项目全部页面':'仅本页面'}}</li>
            </ul>
            <div class="mark_btns">
                <a-button @click="modals.edit={show:true, data:mark}" ><a-icon type="edit" /></a-button>
                <a-button @click="modals.delete={show:true, data:mark}"><a-icon type="delete" /></a-button>
            </div>
        </div>
        <div style="margin:120px 0 0 0; text-align:center" v-if="marks.length==0">暂无数据</div>
        <template slot="footer">
            <a-button key="submit" type="primary" @click="modals.add=true"><a-icon type="plus" />新建标注</a-button>
        </template>
    </a-modal>

    <AddMark :id="id" v-model="modals.add"/>
    <EditMark :data="modals.edit.data" v-model="modals.edit.show"/>
    <DeleteMark :data="modals.delete.data" v-model="modals.delete.show"/>
</div>
</template>


<script>
import { Modal, Checkbox } from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Modal)
Vue.use(Checkbox)

import AddMark from '@/components/manage/mark/add'
import EditMark from '@/components/manage/mark/edit'
import DeleteMark from '@/components/manage/mark/delete'

export default {
    model: {
        prop: 'show',
        event: 'close'
    },
    props: [ 'show', 'id' ],
    components: {
        AddMark,
        EditMark,
        DeleteMark,
    },
    watch: {
        show() {
            this.isShow=this.show
        }
    },
    computed: {
        marks() {
            return this.$store.getters.getMarks(parseInt(this.id))
        }
    },
    data() {
        return {
            isShow:false,
            modals: {
                add: false,
                edit: {
                    show: false,
                    data: {},
                },
                delete: {
                    show: false,
                    data: {},
                }
            }
        }
    },
    methods: {
        addMark(mark) {

        },
        reset(){
            this.$emit("close", false)
        }
  },
}
</script>